import { TypeGuards } from '@codeleap/types'
import { IsDevEnv, Settings } from './Settings'
import { create } from 'apisauce'
import { i18n } from '@lingui/core'

const api = create({
  baseURL: Settings.Fetch[IsDevEnv ? 'DevelopmentURL' : 'ProductionURL'],
  headers: { 'Accept': 'application/json' },
})

const toMultipart = (body: any) => {
  const form = new FormData()

  for (const [key, value] of Object.entries(body)) {
    if (value instanceof File) {
      form.append(key, value)
    } else if (TypeGuards.isArray(value) && value.every(v => v instanceof File)) {
      value.forEach(v => form.append(key, v))
    } else {
      if (TypeGuards.isNil(value)) continue

      form.append(key, JSON.stringify(value))
    }
  }
  return form
}

api.addAsyncRequestTransform(async (req) => {
  try {
    const { ConnectID } = await import('@/services')

    if (!req.headers?.Authorization) {
      let user = await ConnectID.ConnectIDAuth.instance.getUser()

      if (user?.expired) {
        user = await ConnectID.ConnectIDAuth.instance.renewTokenSilently()
      }

      if (user?.access_token) {
        req.headers.Authorization = `Bearer ${user.access_token}`
      }
    }

    if (req?.multipart) {
      const data = toMultipart(req.data)

      req.data = data

      req.headers['Content-Type'] = 'multipart/form-data'
    }

    if (i18n.locale) {
      req.headers['accept-language'] = i18n.locale
    }
  } catch (err) {
    logger.error(err)
  }
})

export { api }
